// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.logos.RentalManagerUserPropertyLogoV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyLogoDeleteV2RequestDto } from '../..';

export const RentalManagerUserPropertyLogoV2WebApiHandler_delete_Path = '/api/web/v2/users/properties/logos/delete';

/**
 * Delete a property logo
 */
export const RentalManagerUserPropertyLogoV2WebApiHandler_delete = (
  postData: UserPropertyLogoDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyLogoDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyLogoV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
